/** 公众号的App ID */
export const APPID = "wx62647e45982163e8";

/** 加密地址 */
export const REDIRECT_URL = encodeURIComponent(window.location.href);

/**
 * @params {string} APPID
 * @params {string} REDIRECT_URL
 * @returns {string} this.$route.query.code
 */
export const AUTHORIZE = () => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URL}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
};

/** 重定向 */ 
export const TCLOUDAPP_URL = 'https://cloud-gjz-8g58y083f0e99ce0-1317994302.tcloudbaseapp.com/'

/** 跳转小程序App ID 测试高净值小秘书 */
// export const LAUNCH_WEAPP_APPID = 'wxa20ea5dd9bacd51c'
// export const LAUNCH_WEAPP_USERNAME = 'gh_3454079573df'

/** 跳转小程序App ID 正式 */
export const LAUNCH_WEAPP_APPID = "wx5b7883ad91802f58";
export const LAUNCH_WEAPP_USERNAME = "gh_beb8cd831cfc";
